'use client';

import { useEffect, useState } from 'react';

export function useDynamicSheetTop() {
  const [top, setTop] = useState(0);

  useEffect(() => {
    const topbars = [
      document.getElementById('topbar-desktop'),
      document.getElementById('topbar-mobile'),
    ].filter(Boolean) as HTMLElement[];

    const header = document.getElementById('main-header');
    if (!header) return;

    let rafId: number | null = null;

    const calculate = () => {
      rafId = null;

      const visibleTopbar = topbars.find(el => el.offsetParent !== null);
      const topbarHeight = visibleTopbar?.offsetHeight ?? 0;
      const headerRect = header.getBoundingClientRect();

      const dynamicTop = Math.max(headerRect.bottom - topbarHeight, 0);

      setTop(dynamicTop);
    };

    const onScroll = () => {
      if (rafId === null) {
        rafId = requestAnimationFrame(calculate);
      }
    };

    const resizeObserver = new ResizeObserver(calculate);
    if (header) resizeObserver.observe(header);
    topbars.forEach(el => resizeObserver.observe(el));

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', calculate);

    calculate();

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', calculate);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return top;
}
